import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        // Init tag wizard input
        window.tag_values.tag_input(this.element)
    }
}
